<template>
  <div >
   <Header />
   <Footer />
  </div>
  <!--

    Header component
    Body 
    Footer

   -->
  <router-view/>
</template>


<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  components:{
    Header,
    Footer
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

html,body{
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
}

#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
